import { useEffect, useState } from "react";
import { emitErrorToast } from "../../lib/errorToast";
import { downloadFile } from "./download";
import type { FileRenderControl } from "./types";

async function downloadOutput(
  url: string | undefined,
  fileName: string,
  setDownloading: (downloading: boolean) => void
) {
  if (!url) return;
  setDownloading(true);
  await downloadFile(url, fileName)
    .catch(() => {
      emitErrorToast({
        icon: "circle-off",
        message: "Couldn’t download this file. Please try again.",
        buttonLabel: "Dismiss",
      });
    })
    .finally(() => setDownloading(false));
}

export function useFileActions({
  url,
  fileName,
  onControls,
}: {
  url: string | undefined;
  fileName: string;
  onControls?: (controls: FileRenderControl[]) => void;
}) {
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    if (!onControls) return;
    onControls([
      {
        id: "download-file",
        icon: "circle-arrow-down",
        label: downloading ? "Downloading…" : "Download",
        disabled: !url || downloading,
        onToggle: () => void downloadOutput(url, fileName, setDownloading),
      },
    ]);
    return () => onControls([]);
  }, [onControls, url, fileName, downloading]);
  return {
    downloading,
    download: () => {
      if (!downloading) void downloadOutput(url, fileName, setDownloading);
    },
  };
}
